/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect } from 'react';
import sidekick from '@last-rev/contentful-sidekick-util';
import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';
import cx from 'clsx';
import { connect } from 'react-redux';
import get from 'lodash/get';
import keys from 'lodash/keys';
import map from 'lodash/map';
import intersection from 'lodash/intersection';
import styles from './CourseCard.module.scss';
import Asset from '../Asset';
import AssetPropTypes from '../Asset/AssetPropTypes';
import ElementLink, { ElementLinkPropTypes } from '../ElementLink/ElementLink';
import { useRouter } from 'next/router';
import useCourseImage from '../../utils/useCourseImage';



const mapStateToProps = (state) => ({
  completedCourseTopics: state.courses.completedCourseTopics,
  completedCourseTopicsLoaded: state.courses.loadedCourseTopics
});

export const CourseCardPropTypes = {
  _id: PropTypes.string,
  _contentTypeId: PropTypes.string,
  headerText: PropTypes.string.isRequired,
  summaryText: PropTypes.string,
  image: PropTypes.shape(AssetPropTypes),
  cta: PropTypes.shape(ElementLinkPropTypes),
  fieldClassNames: PropTypes.object,
  topics: PropTypes.arrayOf(PropTypes.object)
};

function CourseCard({
  _id,
  /* _contentTypeId, */ headerText,
  summaryText,
  image,
  cta,
  fieldClassNames,
  topics,
  // redux state below
  completedCourseTopics,
  completedCourseTopicsLoaded,
  course,
  parent,
  featuredCourseId
}) {
  const router = useRouter()

  const { t, lang } = useTranslation();
  const [percentCompleted, setPercentCompleted] = useState([]);
  const [totalTime, setTotalTime] = useState(0)
  if (parent === "profile") {
    const { courseImage } = useCourseImage(_id, course.image, course.category);
    image = courseImage
  }
  const coursePagerouter = router.asPath.includes("self-guided-learning") ||
    router.asPath.includes("courses") || router.asPath.includes("profile")
  useEffect(() => {
    if (topics?.length && completedCourseTopicsLoaded) {
      const courseTopicIds = map(topics, '_id') || [];
      const completedIds = intersection(keys(get(completedCourseTopics, _id, {})), courseTopicIds);
      setPercentCompleted(completedIds);
    }
  }, [_id, topics, completedCourseTopicsLoaded, completedCourseTopics]);
  useEffect(() => {
    let count = 0
    topics && topics.map((topic, key) => {
      return count = count + topic?.readingTime
    })
    setTotalTime(count)
  }, [])
  const isSvg = image ? image?.url?.split('.').pop() === 'svg' : null;
  const percent = Math.round(100 * (percentCompleted.length / topics.length));

  return (
    <div data-testid="CourseCard" className={cx(styles[fieldClassNames.cardWrap], styles.cardWrap)} key={_id}>
      <ElementLink
        href={cta.href}
        as={cta.as}
        linkText={cta.linkText}
        isModal={false}
        download={false}
        trackingId={`course_card_${cta.href}`}
        className={styles.cardLinkWrap}>
        <div className={cx(styles.card, !isSvg && styles.notSvg)} data-testid="CourseCard-LinkContent">
          {_id === featuredCourseId ? <div className={styles.featureButton}>{t('common:featured')}</div> : ""}

          {image ? <Asset _id={_id} imageWrapClassName={styles.imageWrap} {...image} isInlineSvg={isSvg} height={120} /> : null}
          {headerText || summaryText ? (
            <div className={styles.cardBody} data-testid="CourseCard-TextWrap">
              {headerText ? (
                <div className={styles.cardTitleWrap} {...sidekick(_id, null, null, 'Header Text')}>
                  <h3
                    className={cx(styles[fieldClassNames.cardTitle], styles.cardTitle)}
                    data-testid="CourseCard-title"
                    lang={lang}>
                    {headerText}
                  </h3>
                </div>
              ) : null}
              {summaryText ? (
                <div className={styles.cardTextWrap} {...sidekick(_id, null, null, 'Summary Text')}>
                  <p className={styles.cardText} data-testid="CourseCard-summaryText">
                    {summaryText}
                  </p>
                </div>
              ) : null}
            </div>
          ) : null}
          <div className={styles.moduleTimeWrapper}>
            <span className={styles.modules}>

              {topics.length} {t('common:textTableOfContents')}
            </span>
            <span className={styles.totalTime}>
              {
                totalTime >= 60
                  ? `${Math.floor(totalTime / 60)}h ${totalTime % 60}m`
                  : `${totalTime}m`}
            </span>
          </div>
          {coursePagerouter && percentCompleted?.length > 0 &&
            <div className={styles.moduleProgressBarWrapper}>
              <div className={styles.progressBar}>
                <div
                  className={styles.progressFill}
                  style={{ width: `${percent}%` }}
                >
                </div>

              </div>
              <span>{percent === 100 ?
                <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.530273 4.28027L5.03027 8.78027L13.2803 0.530273" stroke="#1A1918" strokeWidth="1.5" strokeMiterlimit="10" />
                </svg>
                : `${percent}%`}</span>
            </div>
          }

        </div>
      </ElementLink>
    </div>
  );
}

CourseCard.propTypes = CourseCardPropTypes;

CourseCard.defaultProps = {
  summaryText: null,
  image: null,
  cta: null,
  _id: null,
  _contentTypeId: null,
  fieldClassNames: {},
  topics:[]
};

export default connect(mapStateToProps)(CourseCard);
